import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../env";
import { DisplayResrouce } from "../ExplorSpark";
import { LoadingSpinner } from "../../components/loading";

export default function ExploreResource() {

    const navigate = useNavigate()

    const { id } = useParams()
    const [resource, setResource] = useState(undefined)

    useEffect(() => {
        api.get(`resources/${id}`)
            .then(res => setResource(res.data))
            .catch(_ => navigate('.. /..'))        
    }, [id])

    const handleBack = () => {
        navigate('../..')
    }

    return(<div className="standard-padding flex mh-100 columns center justify-center relative">
        <p className="section-title v-spacer-l text-center upper-layer">{resource?.name ?? 'Name NA'}</p>
        {!resource && <LoadingSpinner className={'dashed-card standard-padding flex columns center gap-xs'} style={{width: 'clamp(100px, 85%, 500px)'}} label={'Loading your Resource...'}/>}
        {resource && <DisplayResrouce url={resource.url} mime={resource.type}/>}
        <button className="solid with-icon leading vi-spacer-l upper-layer" onClick={handleBack}><span className="material-symbols-outlined scale-xxs">undo</span>Back</button>
        <div className="es-dot-1"></div>
        <div className="es-dot-2"></div>
    </div>)
}